/* 기획전 페이지 nav */
window.onload = function () {
  const navItems = document.querySelectorAll("  .b7-nav__list .b7-nav__item ");

  if (navItems.length === 0) {
    console.warn("탭 요소(.b7-nav__list .b7-nav__item )를 찾을 수 없습니다.");
    return;
  }

  navItems.forEach(item => {
    const link = item.querySelector(".b7-nav__link");

    link.addEventListener("click", function (e) {
      e.preventDefault(); 
      item.click();        
    });

    item.addEventListener("click", function () {
      navItems.forEach(i => i.classList.remove("b7-nav__item--active"));
      this.classList.add("b7-nav__item--active");
  
      const targetID = this.querySelector("a").getAttribute("href");
      const targetEl = document.querySelector(targetID);

      if (targetEl) {
        targetEl.scrollIntoView({ behavior: "smooth" });
      }
    });
  });
};
